import React, { Component } from 'react';


import * as c from '../../../constants';
import RadioListField from '../../common/RadioListField';
import { injectIntl } from 'react-intl';

import messages from '../../../translation_hotkey_template';

class AddTypeRadioField extends Component {
  getOptions() {
    const { mode, intl } = this.props;
    const groupOpt =  { label: intl.formatMessage( messages.header_group ), value: c.FORM_ADD_TYPE_GROUP };
    const itemOpt = { label: intl.formatMessage( messages.header_item ), value: c.FORM_ADD_TYPE_ITEM };

    if (mode === c.MODAL_MODE_ADD_TAB) {
      return [groupOpt];
    }

    return [groupOpt, itemOpt];
  }


  render() {
    const { label, name, onChange, translation } = this.props;

    return (
      <RadioListField 
        className="inline fields"
        name={name}
        label={label}
        options={this.getOptions()}
        onChange={onChange}
        translation={translation}
      />
    );
  }
}


export default injectIntl(AddTypeRadioField);
